interface OidcConfig {
  authority: string;
  client_id: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
}

const oidcConfig: OidcConfig = {
  authority: 'https://login.microsoftonline.com/a32d3b9a-3662-429a-9cfb-18f510334531/v2.0',
  client_id: 'd5f01a3d-a7a0-4f64-a628-fad3c7ec0f40',
  redirect_uri: window.location.origin + '/signin-oidc',
  response_type: 'code',
  scope: 'openid api://d5f01a3d-a7a0-4f64-a628-fad3c7ec0f40/.default',
};

export default oidcConfig;